<template>
    <div class="row">
        <b-modal  id="modal-related-company" size="xl" scrollable  ok-only>
            <b-input-group class="mb-3">
                <template #prepend>
                    <b-form-select v-model="company.modal.term" :options="company.modal.fields.map(el => {return {value : el.key, text : el.label}}).filter(el => el.value != 'acoes')"/>
                </template>
                <b-form-input :placeholder="`Pesquisar empresas`" v-model="company.modal.filter"></b-form-input>
            </b-input-group>

            <b-table
                head-variant="dark"
                hover
                :items="company.modal.items.filter(el => {
                    const termValue = el[company.modal.term];
                    return termValue !== null && termValue.toLowerCase().includes(company.modal.filter.toLowerCase());
                })"
                :fields="company.modal.fields"
            >
            <template #cell(acoes)="data">
                <b-form-checkbox
                v-model="company.modal.selected"
                name="checkbox-related-company"
                :value="data.item.id"
                @change="updateRelatedCompany( data.item)"
                ></b-form-checkbox>
            </template>
            <template #cell(logoDaEmpresa)="data">
                <b-avatar  :src="data.value"></b-avatar>
                </template>
            </b-table>
        </b-modal>

        <accordion 
            class="col-12"
            id="accordion-empresas" 
            title="Empresas relacionadas"
        >
            <template #append-title>
                <b-button v-if="btnVincular" class="ml-2" size="sm" variant="primary" @click="openCompanyModal">Vincular empresas</b-button>
            </template>

            <div class="table-responsive p-3">
                <b-table head-variant="dark" hover :items="companies" :fields="company.fields">
                <template #cell(logoDaEmpresa)="data">
                    <b-avatar  :src="data.value"></b-avatar>
                </template>
                </b-table>
            </div>
        </accordion>    

    </div>
</template>
<script>

import helpers from "@/common/utils/helpers";
import EmpresasService from "@/common/services/empresas/empresas.service";
import Swal from "sweetalert2";
import Accordion from "@/components/card/Accordion.vue";

export default {
    emits : ['update-related-company'],
    components: {
        Accordion
    },
    props : {
        companies : {
            type : Array,
            default : () => []
        },
        btnVincular : {
            type : Boolean,
            default : true
        }
    },
    data : () => ({
        company : {
            modal : {
                term : "nomeFantasia",
                filter : "",
                selected : [],
                fields : [
                    { key: "acoes", label: "Ações", tdClass: "acoes", },   
                    /*{ key: "logoDaEmpresa", label: "", },*/
                    { key: "nomeFantasia", label: "Empresa(Nome fantasia)", },
                    { key: "cnpj", label: "CNPJ",
                        formatter: (value) => {
                            if (value) return helpers.maskCnpj(value);
                        },
                    },
                    { key: "tipo", label: "Tipo", },
                    /*{ 
                        key: "telefone", label: "Telefone",
                        formatter: (value) => {
                            if (value) return helpers.formatarTelefone(value);
                        },
                    },
                    { key: "email", label: "Email", },
                    { key: "endereco.cidade", label: "Cidade", },*/
                    { key: "endereco.uf", label: "UF", },  
                ],
                items : [],
            }, 
            fields : [
                /*{ key: "logoDaEmpresa", label: "", },*/
                { key: "nomeFantasia", label: "Empresa(Nome fantasia)", },
                { key: "cnpj", label: "CNPJ",
                    formatter: (value) => {
                        if (value) return helpers.maskCnpj(value);
                    },
                },
                { key: "tipo", label: "Tipo", },
                /*{ 
                    key: "telefone", label: "Telefone",
                    formatter: (value) => {
                        if (value) return helpers.formatarTelefone(value);
                    },
                },
                { key: "email", label: "Email", },
                { key: "endereco.cidade", label: "Cidade", },*/
                { key: "endereco.uf", label: "UF", },   
            ]
        }
    }),
    methods:{
        openCompanyModal: function(e){
            e.stopPropagation();
            
            EmpresasService.listar().then((result) => {
                this.company.modal.items = result.data.data.itens;
                /*this.$refs['modal-related-company'].show();*/
                this.$bvModal.show('modal-related-company');
            }).catch((err) => {
                Swal.fire({
                title: this.$t("GERAL.ERRO"),
                text: err.response.data.errors,
                icon: "error",
                });
            });
        },

        updateRelatedCompany: function(item){
            
            this.$emit("update-related-company", {item : item, selected : this.company.modal.selected.some(el => el == item.id)});
        },
        
    },
    mounted: function(){
        this.company.modal.selected = this.companies.map(el => el.id);
    },
    watch : {
        companies : function(newValue){
            this.company.modal.selected = newValue.map(el => el.id);
        }
    }

};
</script>
<style>
    .card, .table-responsive {
        min-height: inherit !important;
    }
    .modal-xl{
    max-width: 90% !important;
  }
</style>